import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import promoColors from '../../../../theme/promoColors';
import promoMedia from '../../../../theme/promoMedia';
import { PromoDangerouslyHtml } from '../promo-dangerously-html/PromoDangerouslyHtml';
import { PromoText } from '../promo-text/PromoText';

const Container = styled.div`
    padding: 18px;
    border-radius: 16px;
    width: 100%;
    height: 177px;
    box-sizing: border-box;
    border: 1px solid ${promoColors.gray20};

    ${promoMedia.desktop1440} {
        height: 187px;
    }
`;
const Number = styled.div`
    margin-bottom: 8px;
`;

export const StepBlock = (props) => {
    return (
        <Container>
            {props.number && (
                <Number>
                    <PromoText variant="h4" color={props.isReversed ? 'white' : 'gray80'}>
                        {props.number}
                    </PromoText>
                </Number>
            )}
            {props.text && <PromoDangerouslyHtml tag="div" color={props.isReversed ? 'white' : 'gray80'} isBold dangerouslyHtml={props.text} />}
        </Container>
    );
};

StepBlock.propTypes = {
    number: PropTypes.string,
    text: PropTypes.string,
    isReversed: PropTypes.bool,
};
